import { firebaseConfig } from '@/config/firebaseConfig';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, query, where, orderBy, getDocs } from 'firebase/firestore';

// Initialize Firebase app and Firestore instance
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export function usePayments() {
  /**
   * Get user's payment history (limit to past 12 months, reduce reads)
   */
  const getUserPayments = async (userId) => {
    try {
      if (!userId) {
        throw new Error('User ID is required');
      }

      // Calculate date 12 months ago
      const now = new Date();
      const twelveMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 12, now.getDate());

      // Firestore expects ISO string for comparison
      const isoDate = twelveMonthsAgo.toISOString();

      const paymentsRef = collection(db, 'payments');
      const q = query(
        paymentsRef,
        where('userId', '==', userId),
        where('createdAt', '>=', isoDate),
        orderBy('createdAt', 'desc')
      );

      const querySnapshot = await getDocs(q);
      const payments = [];

      querySnapshot.forEach((doc) => {
        payments.push({
          id: doc.id,
          ...doc.data()
        });
      });

      return payments;
    } catch (error) {
      console.error('Error fetching user payments:', error);
      throw error;
    }
  };

  return {
    getUserPayments
  };
}
